(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 50))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (!recommendations || !recommendations.innerHTML.trim().length) return;
            this.innerHTML = recommendations.innerHTML;

            // 1. Buttons first, so nothing below can break them
            this.bindCards();

            // 2. Slider and theme helpers, each isolated
            this.initSlider();
          })
          .catch(e => console.error(e));
      };
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }

    initSlider() {
      try {
        const options = JSON.parse(this.dataset.sliderOptions);
        new Swiper(this, options);
      } catch (e) { console.error('Swiper init failed', e); }
      try { if (window.jQuery) jQuery.getScript(window.location.protocol + '//productreviews.shopifycdn.com/embed/loader.js'); } catch (e) {}
      try { if (window.initSwatchOptionImage) window.initSwatchOptionImage(); } catch (e) {}
      try { if (window.initVariantChanger) window.initVariantChanger(this); } catch (e) {}
      try { if (window.initTooltips) window.initTooltips([].slice.call(this.querySelectorAll('[data-bs-toggle="tooltip"]'))); } catch (e) {}
      try { if (window.initCompare) window.initCompare(); } catch (e) {}
    }

    bindCards() {
      const root = this;
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';

      function getMax(card) {
        const select = card.querySelector('.nm-rec-variant');
        const opt = select && select.options[select.selectedIndex];
        const text = opt ? opt.getAttribute('data-max') : card.querySelector('.nm-rec-quantity').getAttribute('data-max');
        const max = text === '' || text === null ? null : parseInt(text, 10);
        return Number.isFinite(max) ? max : null;
      }

      function getVariantId(card) {
        const select = card.querySelector('.nm-rec-variant');
        return select ? select.value : card.dataset.variantId;
      }

      function getQty(card) {
        return parseInt(card.dataset.qty || '1', 10);
      }

      function syncQty(card) {
        const qty = getQty(card);
        const max = getMax(card);
        card.querySelector('.nm-rec-qty').textContent = qty;
        card.querySelector('.nm-rec-minus').disabled = qty <= 1;
        card.querySelector('.nm-rec-plus').disabled = max !== null && qty >= max;
      }

      function updateVariant(card) {
        const select = card.querySelector('.nm-rec-variant');
        if (!select) { syncQty(card); return; }
        const opt = select.options[select.selectedIndex];
        const available = opt.getAttribute('data-available') === 'true';
        card.dataset.qty = '1';
        card.querySelector('.nm-rec-price').textContent = opt.getAttribute('data-price') || card.querySelector('.nm-rec-price').textContent;
        card.querySelector('.nm-rec-add').disabled = !available;
        card.querySelector('.nm-rec-buy').disabled = !available;
        card.querySelector('.nm-rec-quantity').hidden = !available;
        card.querySelector('.nm-rec-status').textContent = available ? '' : 'Sold out';
        syncQty(card);
      }

      function submitProduct(card, isBuy) {
        const add = card.querySelector('.nm-rec-add');
        const buy = card.querySelector('.nm-rec-buy');
        const status = card.querySelector('.nm-rec-status');
        const variantId = getVariantId(card);
        if (!variantId || add.disabled || buy.disabled) return;

        const button = isBuy ? buy : add;
        const original = button.innerHTML;
        button.disabled = true;
        button.innerHTML = isBuy ? 'Loading...' : 'Adding...';
        status.textContent = '';

        const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

        // Use the same section-rendering flow as the working reference section.
        // This lets Shopify return fresh cart drawer, cart bubble and notification HTML.
        const postData = new URLSearchParams();
        postData.set('id', String(variantId));
        postData.set('quantity', String(getQty(card)));
        postData.set(
          'sections',
          'cart-drawer,cart-icon-bubble,cart-notification-content,cart-notification-crosssell-products'
        );
        postData.set('sections_url', window.location.pathname + window.location.search);

        function getLatestCart() {
          if (typeof window.getNammaCart === 'function') {
            return Promise.resolve(window.getNammaCart());
          }
          return fetch(base + 'cart.js?t=' + Date.now(), {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' }
          }).then(response => {
            if (!response.ok) throw new Error('Unable to load cart.');
            return response.json();
          });
        }

        function refreshCartUI(cart, responseData) {
          const requestedSections = 'cart-drawer,cart-icon-bubble,cart-notification-content,cart-notification-crosssell-products';
          const initialSections = responseData && responseData.sections ? responseData.sections : {};
          // Fetch the current sections after adding the product. Some themes return
          // partial section HTML from cart/add.js, so always request a fresh render.
          const sectionsPromise = fetch(base + '?sections=' + encodeURIComponent(requestedSections) + '&_cart_refresh=' + Date.now(), {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
          }).then(response => response.ok ? response.json() : {}).catch(() => ({}));

          return sectionsPromise.then(freshSections => {
            const sections = Object.assign({}, initialSections, freshSections || {});
            const renderData = Object.assign({}, responseData || {}, { sections: sections });

            try {
              const drawer = document.querySelector('cart-drawer');
              const wasOpen = !!(drawer && (
                drawer.classList.contains('active') ||
                drawer.classList.contains('is-open') ||
                drawer.hasAttribute('open') ||
                drawer.getAttribute('aria-hidden') === 'false'
              ));

              if (drawer && typeof drawer.renderContents === 'function' && Object.keys(sections).length) {
                drawer.renderContents(renderData);
                if (!wasOpen && typeof drawer.close === 'function') drawer.close();
              } else if (drawer && sections['cart-drawer']) {
                const parsedDrawer = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
                const freshDrawer = parsedDrawer.querySelector('cart-drawer');
                if (freshDrawer) {
                  drawer.innerHTML = freshDrawer.innerHTML;
                  if (wasOpen) {
                    drawer.classList.add('active');
                    drawer.classList.add('is-open');
                    drawer.setAttribute('open', '');
                  } else {
                    drawer.classList.remove('active', 'is-open');
                    drawer.removeAttribute('open');
                  }
                }
              }
            } catch (error) {
              console.warn('Cart drawer refresh skipped:', error);
            }

            try {
              if (sections['cart-icon-bubble']) {
                const parsedBubble = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
                const newBubble = parsedBubble.querySelector('#cart-icon-bubble');
                const oldBubble = document.querySelector('#cart-icon-bubble');
                if (newBubble && oldBubble) oldBubble.replaceWith(newBubble);
              }
            } catch (error) {
              console.warn('Cart bubble refresh skipped:', error);
            }

            try {
              const notification = document.querySelector('cart-notification');
              if (notification && Object.keys(sections).length && typeof notification.updateContent === 'function') {
                notification.updateContent(sections);
              } else if (notification && sections['cart-notification-content']) {
                const parsedNotification = new DOMParser().parseFromString(sections['cart-notification-content'], 'text/html');
                const freshNotification = parsedNotification.querySelector('#cart-notification-product, .cart-notification-product, cart-notification');
                const target = notification.querySelector('#cart-notification-product, .cart-notification-product');
                if (freshNotification && target) target.replaceWith(freshNotification);
              }
            } catch (error) {
              console.warn('Cart notification refresh skipped:', error);
            }

            let refreshHook = Promise.resolve();
            if (typeof window.refreshNammaCartDrawer === 'function') {
              refreshHook = Promise.resolve(window.refreshNammaCartDrawer(cart)).catch(error => {
                console.warn('Custom cart refresh hook skipped:', error);
              });
            }

            return refreshHook.then(() => {
              try {
                if (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate && typeof window.publish === 'function') {
                  window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-recommendations',
                    cartData: cart
                  });
                }
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
                document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart } }));
                document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
                document.dispatchEvent(new CustomEvent('cart:updated:ajax', { detail: { cart: cart } }));
                document.dispatchEvent(new CustomEvent('product:added-to-cart', {
                  detail: { cart: cart, source: 'product-recommendations' }
                }));
                if (window.Shopify && typeof window.Shopify.onCartUpdate === 'function') {
                  window.Shopify.onCartUpdate();
                }
              } catch (error) {
                console.warn('Cart update event skipped:', error);
              }
            });
          });
        }

        fetch(base + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: postData.toString()
        })
          .then(response => response.json().catch(() => ({})).then(data => {
            if (!response.ok) {
              throw new Error(data.description || data.message || 'Unable to add product');
            }
            return data;
          }))
          .then(data => {
            if (isBuy) {
              window.location.href = base + 'cart';
              return;
            }

            return getLatestCart().then(cart => {
              return refreshCartUI(cart, data).then(() => {
                // Keep the confirmation inside the Add to Cart button only.
                button.innerHTML = '✓ Added to cart';
                status.textContent = '';
                setTimeout(() => {
                  button.innerHTML = original;
                  button.disabled = false;
                }, 1600);
              });
            });
          })
          .catch(error => {
            status.textContent = error.message || 'Please try again';
            button.innerHTML = original;
            button.disabled = false;
          });
      }

      // Delegated click handler: works for Swiper clones too
      root.addEventListener('click', function (e) {
        const btn = e.target.closest('.nm-rec-add, .nm-rec-buy, .nm-rec-minus, .nm-rec-plus');
        if (!btn || !root.contains(btn)) return;
        const card = btn.closest('.nm-rec-card');
        if (!card) return;
        e.preventDefault();
        e.stopPropagation();

        if (btn.classList.contains('nm-rec-minus')) {
          if (getQty(card) > 1) { card.dataset.qty = String(getQty(card) - 1); syncQty(card); }
        } else if (btn.classList.contains('nm-rec-plus')) {
          const max = getMax(card);
          if (max === null || getQty(card) < max) { card.dataset.qty = String(getQty(card) + 1); syncQty(card); }
        } else {
          submitProduct(card, btn.classList.contains('nm-rec-buy'));
        }
      }, true);

      root.addEventListener('change', function (e) {
        if (!e.target.classList.contains('nm-rec-variant')) return;
        const card = e.target.closest('.nm-rec-card');
        if (card) updateVariant(card);
      });

      root.querySelectorAll('.nm-rec-card').forEach(updateVariant);
    }
  }
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["textiles-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nm-fashion]').forEach(function(section){
    section.querySelectorAll('[data-finder-group]').forEach(function(group){
      group.querySelectorAll('button').forEach(function(button){
        button.addEventListener('click',function(){
          group.querySelectorAll('button').forEach(function(item){item.classList.remove('is-active')});
          button.classList.add('is-active');
          var occasion=section.querySelector('[data-finder-group="occasion"] .is-active').dataset.value;
          var audience=section.querySelector('[data-finder-group="audience"] .is-active').dataset.value;
          section.querySelector('[data-match-link]').setAttribute('aria-label','Show '+occasion+' looks for '+audience);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
